export const sellers_Marketplaces = [
	{
		icon: '☝️',
		title: 'sellersData_title1',
		subtitle: 'sellersData_subtitle1',
	},
	{
		icon: '🚀',
		title: 'sellersData_title2',
		subtitle: 'sellersData_subtitle2',
	},
	{
		icon: '👠',
		title: 'sellersData_title3',
		subtitle: 'sellersData_subtitle3',
	},
	{
		icon: '💪',
		title: 'sellersData_title4',
		subtitle: 'sellersData_subtitle4',
	},
];
